import React from "react";

export const updateFormData = (state, action, dataType) => {
    return dataType.map(field => {
        if (field.key === action.key) {
            return {
                ...field,
                value: action.value
            }
        }

        return field
    })
}
